import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=8f4a75c4&scoped=true&"
import script from "./VendorList.vue?vue&type=script&lang=js&"
export * from "./VendorList.vue?vue&type=script&lang=js&"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=8f4a75c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4a75c4",
  null
  
)

component.options.__file = "VendorList.vue"
export default component.exports